import React from "react";
import ReactSlider from "react-slider";
import { RateAgreementOptions } from "../../../types/RateAgreementOptions";
import { RateData } from "../../../types/RateData";

export const RateAmountSlider: React.FC<{
    rateData: RateData;
    rateAgreementOptions: RateAgreementOptions;
    onChange: ((value: number, index: number) => void) | undefined;
}> = (props) => (
    <ReactSlider
        className={"slider"}
        defaultValue={props.rateData.rateAmount}
        max={props.rateAgreementOptions.maxRate}
        min={props.rateAgreementOptions.minRate}
        orientation={"horizontal"}
        thumbClassName="example-thumb"
        trackClassName="example-track"
        value={props.rateData.rateAmount}
        withTracks={true}
        onChange={props.onChange}
    />
);
